module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/home-slides/prod-08-4e9a2cd8296b790765c2f4f5da7b8912.jpg";